module.exports = __webpack_public_path__ + "img/license_image5.73206218.png";